import type { usePopover } from 'minimal-shared/hooks';

import { MenuItem, MenuList, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { Iconify } from 'src/components/iconify';

import { CustomPopover } from '../../../custom-popover';

// ----------------------------------------------------------------------

type Props = {
  menuActions: ReturnType<typeof usePopover>;
  isTenantInvoice?: boolean;
  selectedId?: { id: string; status?: string };
  currentTenantId?: string;
  handleMarkAsRead?: (id: string) => void;
  /** When set, View is disabled and this text explains why. */
  invoiceLockedMessage?: string;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function TableRowActions({
  menuActions,
  isTenantInvoice,
  selectedId,
  currentTenantId,
  handleMarkAsRead,
  invoiceLockedMessage = '',
  t,
}: Props) {
  return (
    <CustomPopover
      open={menuActions.open}
      anchorEl={menuActions.anchorEl}
      onClose={menuActions.onClose}
      slotProps={{ arrow: { placement: 'right-top' } }}
    >
      <MenuList>
        {invoiceLockedMessage ? (
          <MenuItem disabled>
            <Iconify icon="solar:eye-bold" />
            {t('VIEW')}
          </MenuItem>
        ) : (
          <MenuItem
            component={RouterLink}
            href={
              isTenantInvoice
                ? paths.tenant.invoice(currentTenantId || '', selectedId?.id || '')
                : paths.setting.billing.details(selectedId?.id || '')
            }
            onClick={menuActions.onClose}
          >
            <Iconify icon="solar:eye-bold" />
            {t('VIEW')}
          </MenuItem>
        )}

        {isTenantInvoice && selectedId && selectedId?.status !== 'paid' && (
          <MenuItem
            onClick={() => {
              handleMarkAsRead?.(selectedId?.id);
              menuActions.onClose();
            }}
            disabled={selectedId?.status === 'paid' || !!invoiceLockedMessage}
          >
            <Iconify icon="mdi:check-circle" />
            {t('MARK_TO_PAID')}
          </MenuItem>
        )}

        {invoiceLockedMessage && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', px: 1, pb: 0.5, maxWidth: 220 }}
          >
            {invoiceLockedMessage}
          </Typography>
        )}
      </MenuList>
    </CustomPopover>
  );
}
